<template>
  <div>
    <section class="learning-intro">
      <div>
        <span class="learning-eyebrow">
          <feather-icon icon="BookOpenIcon" size="14" />
          Mon espace d’apprentissage
        </span>
        <h1>Bonjour, voici vos cours</h1>
        <p>Retrouvez vos groupes et les derniers supports partagés par vos enseignants.</p>
      </div>
      <div
        v-if="!loading && groups.length"
        class="learning-summary"
      >
        <div class="learning-summary-item">
          <strong>{{ groups.length }}</strong>
          <span>Groupe(s)</span>
        </div>
        <div class="learning-summary-item">
          <strong>{{ totalMaterials }}</strong>
          <span>Support(s)</span>
        </div>
      </div>
    </section>

    <div
      v-if="loading"
      class="ma-loading"
    >
      Chargement…
    </div>

    <div
      v-else-if="!groups.length"
      class="ma-card ma-empty"
    >
      <div class="ma-empty-ico">
        <feather-icon
          icon="LayersIcon"
          size="30"
        />
      </div>
      <h4>Rejoindre nos cours</h4>
      <p>Vous n'êtes encore inscrit à aucun cours. Contactez-nous sur Facebook pour rejoindre l'un de nos groupes et accéder aux supports de vos enseignants.</p>
      <a
        class="ma-join-btn"
        href="https://www.facebook.com/Mindsacademy13"
        target="_blank"
        rel="noopener"
      >
        <feather-icon
          icon="MessageCircleIcon"
          size="18"
        />
        Rejoindre nos cours sur Facebook
      </a>
    </div>

    <div
      v-else
      class="learning-groups-grid"
    >
      <article
        v-for="g in groups"
        :key="g._id"
        class="learning-group-card"
        @click="open(g)"
      >
        <div
          class="learning-group-cover"
          style="background: linear-gradient(135deg, #FF8A6B 0%, #E24E32 100%);"
        >
          <span class="learning-group-icon">
            <feather-icon icon="BookOpenIcon" size="20" />
          </span>
          <span class="learning-group-code">{{ g.code }}</span>
        </div>
        <div class="learning-group-body">
          <h2>{{ g.name }}</h2>
          <div class="learning-group-tags">
            <span
              v-if="g.level"
              class="ma-badge level"
            >{{ g.level }}</span>
            <span
              v-if="g.subject"
              class="ma-badge subject"
            >{{ g.subject }}</span>
          </div>
          <div class="learning-group-footer">
            <span>
              <feather-icon
                icon="UserIcon"
                size="14"
              />
              {{ (g.tutor && g.tutor.fullName) || 'Enseignant' }}
            </span>
            <span class="learning-open">
              Consulter
              <feather-icon icon="ArrowRightIcon" size="14" />
            </span>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import axios from '@axios'

export default {
  name: 'MindsStudentGroups',
  data() {
    return { groups: [], loading: true }
  },
  computed: {
    totalMaterials() {
      return this.groups.reduce((total, group) => total + (group.materialCount || 0), 0)
    },
  },
  mounted() { this.fetch() },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await axios.get('/ma/student/groups')
        this.groups = res.data.groups || []
      } catch (e) {
        this.groups = []
      } finally {
        this.loading = false
      }
    },
    open(g) {
      this.$router.push({ name: 'minds-student-group', params: { id: g._id } })
    },
  },
}
</script>

<style src="../admin/minds.css"></style>
<style src="../learning.css"></style>

<style scoped>
.ma-join-btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-top: 18px;
  padding: 12px 22px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ff6f59, #b23a26);
  color: #fff;
  font-size: 0.92rem;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(178, 58, 38, 0.24);
  transition: transform 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;
}

.ma-join-btn:hover {
  transform: translateY(-2px);
  filter: brightness(1.03);
  box-shadow: 0 14px 30px rgba(178, 58, 38, 0.32);
  color: #fff;
}
</style>
